import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";

export default function NotFoundPage() {
    return (
        <main className="py-24 px-6 max-w-4xl mx-auto text-center min-h-[50vh]">
            <Seo title="Página não encontrada — ScorpionPDF" description="A página procurada não existe ou o link expirou." />
            <p className="font-poster text-8xl text-[#0284C7]">404</p>
            <h1 className="font-poster text-3xl text-black mt-2">Página não encontrada</h1>
            <p className="text-gray-700 mt-3">
                O endereço pode estar errado ou o resultado da sua operação já expirou (arquivos são excluídos em até
                60 minutos).
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
                <Link
                    to="/ferramentas"
                    data-testid="notfound-catalog-link"
                    className="px-8 py-4 bg-[#0284C7] hover:bg-black text-white font-poster text-xl tracking-wide transition-colors"
                >
                    ABRIR FERRAMENTAS
                </Link>
                <Link
                    to="/"
                    data-testid="notfound-home-link"
                    className="px-8 py-4 border-2 border-black bg-white hover:bg-black hover:text-white text-black font-poster text-xl tracking-wide transition-colors"
                >
                    PÁGINA INICIAL
                </Link>
            </div>
        </main>
    );
}
